import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { OSWindow } from "@/components/os/Window";
import { Taskbar } from "@/components/os/Taskbar";
import { PixelHeart, PixelStar, PixelBolt } from "@/components/os/Stickers";

interface OSChromeProps {
  id: string;
  title: string;
  tint?: string;
  maxW?: string;
  children: React.ReactNode;
}

export const OSChrome = ({ id, title, tint = "white", maxW = "max-w-5xl", children }: OSChromeProps) => {
  const [minimized, setMinimized] = useState(false);
  const nav = useNavigate();

  return (
    <div className="desktop-bg relative min-h-screen overflow-x-clip">
      <div className="pointer-events-none absolute left-[6%] top-10 hidden md:block" aria-hidden>
        <PixelHeart px={4} className="opacity-70" />
      </div>
      <div className="pointer-events-none absolute right-[8%] top-24 hidden md:block" aria-hidden>
        <PixelStar px={4} className="opacity-70" />
      </div>
      <div className="pointer-events-none absolute bottom-32 left-[12%] hidden md:block" aria-hidden>
        <PixelBolt px={4} className="opacity-50" />
      </div>

      <div className="flex justify-center px-3 pb-28 pt-8 sm:px-6 sm:pt-12">
        <AnimatePresence>
          {!minimized && (
            <OSWindow
              id={id}
              title={title}
              tint={tint}
              isStatic
              onClose={() => nav("/")}
              onMinimize={() => setMinimized(true)}
              className={`relative w-full ${maxW}`}
            >
              {children}
            </OSWindow>
          )}
        </AnimatePresence>
      </div>

      <Taskbar windows={[{ id, title, active: !minimized, onClick: () => setMinimized(false) }]} />
    </div>
  );
};
